import { render, staticRenderFns } from "./PageHeading.ts.vue?vue&type=template&id=7154f3ac&"
import script from "./PageHeading.ts.vue?vue&type=script&lang=ts&"
export * from "./PageHeading.ts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports